var map = {
	"./EN": [
		54
	],
	"./EN.js": [
		54
	],
	"./PL": [
		55
	],
	"./PL.js": [
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 211;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*$
// module id = 211
// module chunks = 6